import React from 'react';
import { mobilePaymentsStrings } from '@/constants/residents/strings';
import { PaymentBottomSheet } from './PaymentBottomSheet';

interface PrimaryLeaseholderTooltipProps {
  visible: boolean;
  onClose: () => void;
}

/**
 * Primary Leaseholder Tooltip
 * Bottom sheet that explains the primary leaseholder icon
 * Matches Figma design 8860-153302 (Tooltip)
 */
export const PrimaryLeaseholderTooltip: React.FC<PrimaryLeaseholderTooltipProps> = ({
  visible,
  onClose,
}) => {
  return (
    <PaymentBottomSheet
      visible={visible}
      onClose={onClose}
      title={mobilePaymentsStrings.primaryLeaseholderTooltip}
      titleStyle="body"
    />
  );
};
